import { z } from 'zod/v4';

import { normalizeVideoWidgetArgs } from './video-widget-args.normalization';
import { partialVideoWidgetDataSchema, videoUrlSchema } from './partial-video-widget-data.schema';

/**
 * `url` is the one field promoted from optional to REQUIRED on create. entity-core's factory starts
 * at `videoUrl: ''`, which is a legal draft on disk (the editor lets a user drop the widget and fill
 * the link in afterwards) but renders as an empty grey box — never what a model creating a video
 * means. Declared with `.extend()` on the shared partial rather than a copied field list.
 */
const createVideoWidgetDataSchema = partialVideoWidgetDataSchema.extend({ url: videoUrlSchema });

const createVideoWidgetObjectSchema = z.object({
    columnId: z.string().describe('Id of the column to create the video widget in.'),
    index: z
        .number()
        .int()
        .min(0)
        .optional()
        .describe("Position within the column's widget list (0-based). Omit to append at the end."),
    data: createVideoWidgetDataSchema.describe(
        'Video widget data. Only url is required; the source, poster and aspect ratio come from it, and ' +
            'sizing and alignment fall back to sane defaults.'
    ),
});

export const createVideoWidgetArgsSchema = z.preprocess(normalizeVideoWidgetArgs, createVideoWidgetObjectSchema);
